/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportCostsByJobRole
 */
export interface ReportCostsByJobRole {
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByJobRole
     */
    jobRoleId: number;
    /**
     * 
     * @type {string}
     * @memberof ReportCostsByJobRole
     */
    jobRole: string;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByJobRole
     */
    employees: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ReportCostsByJobRole
     */
    employeeIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByJobRole
     */
    shifts: number;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByJobRole
     */
    hoursScheduled: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByJobRole
     */
    hoursWorked: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByJobRole
     */
    costsScheduled: number | null;
    /**
     * 
     * @type {number}
     * @memberof ReportCostsByJobRole
     */
    costsWorked: number | null;
}

/**
 * Check if a given object implements the ReportCostsByJobRole interface.
 */
export function instanceOfReportCostsByJobRole(value: object): value is ReportCostsByJobRole {
    if (!('jobRoleId' in value) || value['jobRoleId'] === undefined) return false;
    if (!('jobRole' in value) || value['jobRole'] === undefined) return false;
    if (!('employees' in value) || value['employees'] === undefined) return false;
    if (!('employeeIds' in value) || value['employeeIds'] === undefined) return false;
    if (!('shifts' in value) || value['shifts'] === undefined) return false;
    if (!('hoursScheduled' in value) || value['hoursScheduled'] === undefined) return false;
    if (!('hoursWorked' in value) || value['hoursWorked'] === undefined) return false;
    if (!('costsScheduled' in value) || value['costsScheduled'] === undefined) return false;
    if (!('costsWorked' in value) || value['costsWorked'] === undefined) return false;
    return true;
}

export function ReportCostsByJobRoleFromJSON(json: any): ReportCostsByJobRole {
    return ReportCostsByJobRoleFromJSONTyped(json, false);
}

export function ReportCostsByJobRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportCostsByJobRole {
    if (json == null) {
        return json;
    }
    return {
        
        'jobRoleId': json['jobRoleId'],
        'jobRole': json['jobRole'],
        'employees': json['employees'],
        'employeeIds': json['employeeIds'],
        'shifts': json['shifts'],
        'hoursScheduled': json['hoursScheduled'],
        'hoursWorked': json['hoursWorked'],
        'costsScheduled': json['costsScheduled'],
        'costsWorked': json['costsWorked'],
    };
}

  export function ReportCostsByJobRoleToJSON(json: any): ReportCostsByJobRole {
      return ReportCostsByJobRoleToJSONTyped(json, false);
  }

  export function ReportCostsByJobRoleToJSONTyped(value?: ReportCostsByJobRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'jobRoleId': value['jobRoleId'],
        'jobRole': value['jobRole'],
        'employees': value['employees'],
        'employeeIds': value['employeeIds'],
        'shifts': value['shifts'],
        'hoursScheduled': value['hoursScheduled'],
        'hoursWorked': value['hoursWorked'],
        'costsScheduled': value['costsScheduled'],
        'costsWorked': value['costsWorked'],
    };
}

